import { useEffect, useState } from 'react';
import {
  getCachedVerifiedDevices,
  subscribeVerifiedDevices,
  type VerifiedDevicesCatalog,
} from '../services/verifiedDevicesService';
import {
  matchZoneToVerifiedCatalog,
  type VerifiedDeviceEntry,
} from '../utils/verifiedDevicesUtils';

export function useVerifiedDevicesCatalog() {
  const [catalog, setCatalog] = useState<VerifiedDevicesCatalog>(getCachedVerifiedDevices);

  useEffect(() => subscribeVerifiedDevices(setCatalog), []);

  return catalog;
}

export function useVerifiedDeviceMatch(
  zoneName: string | null | undefined,
  manufacturerHint?: string | null,
): VerifiedDeviceEntry | null {
  const catalog = useVerifiedDevicesCatalog();
  return matchZoneToVerifiedCatalog(zoneName, manufacturerHint ?? null, catalog.devices);
}
